import styled, {css} from 'styled-components';

import {breakpoint, colors, font} from '../../../theme';

const tabStyles = css<{step?: number; active?: boolean; passed?: boolean; hasError?: boolean}>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 12px;
    margin-bottom: 10px;
    word-wrap: break-word;
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
    flex: 1;
    padding-bottom: 10px;
    border: none;
    color: ${(p) => (p.active ? colors.brandPrimary : '#1d2229')};
    transition: all 0.15s ease-in-out;
    text-transform: uppercase;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: ${(p) => (p.active ? '3px' : '1px')};
        background: ${(p) => (p.active || p.passed ? colors.brandPrimary : '#E7E8EA')};
        transition: all 0.2s ease-in-out;
    }

    &:before {
        content: ${(p) =>
            p.passed
                ? 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS44ODA4IDAuNjM1MTI5QzEyLjE5MzYgMC44NjEwNyAxMi4yNTkyIDEuMjkxMzQgMTIuMDI3NCAxLjU5NjE2TDYuNDM5MzMgOC45NDQwOEM1Ljk3NTIgOS41NTQzOSA1LjA5MTAyIDkuNjgxNzkgNC40NjU1NiA5LjIyODQ5TDAuNDUwMzM1IDYuMzE4NDdDMC4xMzc5NDEgNi4wOTIwNiAwLjA3MzAwNjYgNS42NjE3IDAuMzA1MyA1LjM1NzIyQzAuNTM3NTk0IDUuMDUyNzQgMC45NzkxNTEgNC45ODk0NSAxLjI5MTU1IDUuMjE1ODZMNS4zMDY3NyA4LjEyNTg4TDEwLjg5NDggMC43Nzc5NThDMTEuMTI2NiAwLjQ3MzEzNSAxMS41NjgxIDAuNDA5MTg5IDExLjg4MDggMC42MzUxMjlaIiBmaWxsPSIjNjQ2NkU5Ii8+Cjwvc3ZnPgo=")'
                : `"${p.step}"`};
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${(p) => (p.active || p.passed ? colors.white : colors.textMuted)};
        border-color: ${(p) =>
            p.active ? colors.transparent : p.passed ? colors.brandPrimary : colors.textMuted};
        border-style: solid;
        border-width: 2px;
        border-radius: 50%;
        background: ${(p) => (p.active ? colors.brandPrimary : colors.white)};

        ${(p) =>
            p.hasError &&
            css`
                border-color: ${colors.danger};
                background: ${colors.dangerSecondary};
                color: ${colors.danger};
                content: '!';
            `}
    }

    a {
        font-size: 14px;
    }

    &:focus {
        outline: none;
    }

    @media (max-width: ${breakpoint.tablet}) {
        padding: 0 5px 5px 5px;
    }
`;
export const Tab = styled.div<{
    step?: number;
    active?: boolean;
    passed?: boolean;
    hasError?: boolean;
}>`
    ${tabStyles};
`;

export const ClickableTab = styled.button<{step?: number; active?: boolean; passed?: boolean}>`
    ${tabStyles};
    background: transparent;
    cursor: pointer;
    padding: 13px 0;
    min-height: 56px;
    font-family: ${font.family.primary};

    &:hover {
        background: ${colors.brandLight};
    }
`;

export const TabList = styled.div<{extraStyles?: string}>`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 30px;
    ${(p) => p.extraStyles ?? ''}
`;
